module.exports = __webpack_public_path__ + "static/media/login_fail_social.af446b43.jpg";